import {
  FspRange,
  OrganisationProductSummary,
  RepurchaseDateRange,
} from "@fero/components";
import type { LoadedFspValues } from "@fero/hooks";
import { Stack, TableCell, TableRow } from "@mui/material";
import type { WithDbId } from "adl-gen/common/db";
import type { ProductDealLeg } from "adl-gen/ferovinum/app/api";
import type { Currency, Product } from "adl-gen/ferovinum/app/db";
import type { FSP } from "adl-gen/ferovinum/app/views";
import { CurrencyRange } from "components/widgets/currency-renderer/currency-range";
import { getVesselCapacity, isSingles } from "utils/model-utils";
import { useProductRowViewModel } from "./use-product-row.view-model";

interface Props {
  fspValues: LoadedFspValues;
  productWithId: WithDbId<Product>;
  productDealLegs: ProductDealLeg[];
  currency: Currency;
}

export const ProductRow = ({
  fspValues,
  productWithId,
  productDealLegs,
  currency,
}: Props) => {
  const { totalUnsoldQuantity, fspTransformation, deposits, accessor } =
    useProductRowViewModel(productDealLegs);

  return (
    <TableRow>
      <TableCell>
        <OrganisationProductSummary
          {...productWithId.value}
          productId={productWithId.id}
          vesselCapacity={getVesselCapacity(
            productWithId.value.vesselSize,
            totalUnsoldQuantity,
          )}
        />
      </TableCell>
      <TableCell align="right">
        <Stack direction="row" justifyContent="flex-end">
          <RepurchaseDateRange
            repurchaseStages={productDealLegs.flatMap((dl) => [
              dl.compulsorySaleStage,
              dl.finalStage,
            ])}
          />
        </Stack>
      </TableCell>
      {isSingles(totalUnsoldQuantity) && (
        <TableCell align="right">{totalUnsoldQuantity.value}</TableCell>
      )}
      <TableCell align="right">
        <FspRange<FSP>
          values={fspValues}
          transformation={fspTransformation}
          currency={currency}
          accessor={accessor}
        />
      </TableCell>
      <TableCell align="right">
        <CurrencyRange currency={currency} values={deposits} />
      </TableCell>
    </TableRow>
  );
};
